
import { defineComponent, reactive, toRefs } from 'vue'
import { AssertGoodResponse, getRandomFromArr } from '@/util/GlobalUtil'
import { useGetRequest } from '@/hooks'
import { useRouter } from 'vue-router'
import { BlogConditionStrategies } from '@/interfaces'

export default defineComponent({
  setup() {
    // State
    const router = useRouter()
    const state = reactive({
      isLoading: true,
      tags: [],
    })
    const randomTagType = () =>
      getRandomFromArr(['info', '', 'danger', 'warning', 'success'])
    // 调接口,获取所有Tag
    useGetRequest('/api/tag').then((res) => {
      AssertGoodResponse(res)
      state.tags = res.data.data
      state.isLoading = false
    })

    // 跳转到conditon页面, 查看当前类型下的所有博客
    // eslint-disable-next-line
    const toThisTag = (tag: any) => {
      router.push({
        name: 'ConditionBlogs',
        params: {
          conditionStrategy: BlogConditionStrategies.BY_TAG,
          value: tag.id
        },
        query:{
          conditionStrategy: BlogConditionStrategies.BY_TAG,
          value: tag.id
        }
      })
    }

    return {
      ...toRefs(state),
      randomTagType,
      toThisTag,
    }
  },
})
